import React from 'react';
import Avatar from './Avatar.jsx';

function csrfToken() {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el ? el.getAttribute('content') : '';
}

function signOut() {
  fetch('/session', {
    method: 'DELETE',
    headers: { 'X-CSRF-Token': csrfToken(), Accept: 'text/html' },
    credentials: 'same-origin',
    // 'manual', not 'follow': the DELETE redirects to /session/new. With 'follow',
    // fetch re-issues the request against the Location and a 302 keeps the DELETE
    // method (-> 404 on /session/new). 'manual' returns an opaqueredirect (status 0),
    // which the guard below treats as success, and we navigate ourselves.
    redirect: 'manual'
  })
    .then((res) => {
      if (!res.ok && res.status !== 0) {
        // Surface the failure so a stale CSRF token / network error doesn't
        // silently pretend sign-out succeeded.
        window.alert('Sign-out failed. Reload the page and try again.');
        return;
      }
      window.location = '/session/new';
    })
    .catch(() => {
      window.alert('Sign-out failed. Check your connection and try again.');
    });
}

export default function HeaderUserChip({ user }) {
  if (!user) return null;
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <Avatar initials={user.initials} seed={user.name} size={26} />
      <span style={{ fontSize: 12, fontWeight: 500, color: '#1A1A1A' }}>{user.name}</span>
      <button
        type="button"
        onClick={signOut}
        style={{
          marginLeft: 8,
          fontSize: 11,
          color: '#6B6B68',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '2px 6px'
        }}
      >Sign out</button>
    </div>
  );
}
